import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";

import { DffFormControlModule } from "@dffedb/forms";
import { AccordionStatusIndicatorModule } from "@dffedb/ui";
import { NoteModule } from "@e-forsyning/common/note";

import { ServicerapportAccordionPanelModule } from "../shared/servicerapport-accordion-panel/servicerapport-accordion-panel.module";
import { KomponentGruppeComponent } from "./komponent-gruppe/komponent-gruppe.component";
import { KomponentNoteListeComponent } from "./komponent-note-liste/komponent-note-liste.component";
import { KomponentTyperDialogComponent } from "./komponent-typer-dialog/komponent-typer-dialog.component";
import { KomponentTyperComponent } from "./komponent-typer/komponent-typer.component";
import { KomponentComponent } from "./komponent/komponent.component";

@NgModule({
    imports: [
        AccordionStatusIndicatorModule,
        CommonModule,
        DffFormControlModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatExpansionModule,
        NoteModule,
        ReactiveFormsModule,
        ServicerapportAccordionPanelModule
    ],
    exports: [KomponentComponent, KomponentGruppeComponent, KomponentNoteListeComponent, KomponentTyperComponent],
    declarations: [
        KomponentComponent,
        KomponentGruppeComponent,
        KomponentNoteListeComponent,
        KomponentTyperComponent,
        KomponentTyperDialogComponent
    ],
    providers: []
})
export class KomponenterModule {}
